import React, { FC, HTMLAttributes } from 'react'
import { StyledText } from '../Paragraph/Paragraph.style'
import { IText } from '../Paragraph'

const Text: FC<IText & HTMLAttributes<HTMLSpanElement>> = (props: IText) => {
  return <StyledText {...props}>{props.children}</StyledText>
}

export default Text
